export const maskAssetUrl = (url: string): string =>
  url.replace('a.storyblok.com', process.env.GATSBY_ROCHE_ASSET_URL_MASK);
